import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77b1a912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-info xag-flex-lr" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "xag-flex-lr" }
const _hoisted_4 = { class: "xag-flex-lr" }
const _hoisted_5 = {
  key: 0,
  class: "num"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "child-product-container" }
const _hoisted_8 = { class: "child-product-top xag-flex-lr" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "套餐包含如下产品", -1))
const _hoisted_10 = { class: "child-product-wrap" }
const _hoisted_11 = { class: "child-product-list" }
const _hoisted_12 = { class: "list-item-name-num xag-flex-lr" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = { class: "num" }

import { ref, computed, withDefaults } from 'vue'
import { Popup } from 'vant'
import { ChildProductItem, ProductItem } from '@/types/device-replace-v3'


export default /*#__PURE__*/_defineComponent({
  __name: 'activity-product-item',
  props: {
    name: { default: '' },
    images: { default: () => [''] },
    child: { default: () => [] },
    showMore: { type: Boolean, default: true },
    showCount: { type: Boolean, default: false }
  },
  emits: ['updatePopupShow'],
  setup(__props: any, { emit: emits }) {

const props = __props as { name: string, images: Array<string>, child: Array<ChildProductItem>, showMore: boolean, showCount: boolean };



const pHeightMax = computed(() => {
  const height = window.innerHeight
  return height * 0.9 - 40
})

const viewChild = ref(false)
function viewMore() {
  viewChild.value = true
}
function getProductItemStyle(images: string[]) {
  return images[0] ? `background-image: url(${images[0]})` : ''
}
function onOpen() {
  emits('updatePopupShow', true)
}
function onClose() {
  emits('updatePopupShow', false)
}
function onClick(event: MouseEvent) {
  event.stopPropagation()
}
function onclickoverlay(event: MouseEvent) {
  event.stopPropagation()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "img",
        style: _normalizeStyle(getProductItemStyle(__props.images))
      }, null, 4),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["name xag-ellipsis", __props.showCount ? 'with-count' : ''])
          }, _toDisplayString(__props.name), 3),
          _createElementVNode("div", _hoisted_4, [
            (__props.showCount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "x1"))
              : _createCommentVNode("", true),
            (__props.showMore)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 1,
                  class: "icon-arrow-right-svg",
                  onClick: _withModifiers(viewMore, ["stop"])
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]),
        _renderSlot(_ctx.$slots, "info-extra")
      ])
    ]),
    _createVNode(_unref(Popup), {
      show: viewChild.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((viewChild).value = $event)),
      "safe-area-inset-bottom": "",
      round: "",
      position: "bottom",
      style: _normalizeStyle({ height: 'auto', maxHeight: `${_unref(pHeightMax)}px` }),
      "lock-scroll": "",
      onOpen: onOpen,
      onClose: onClose,
      onClick: onClick,
      onClickOverlay: onclickoverlay
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("i", {
              class: "icon-close-svg",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (viewChild.value = false), ["stop"]))
            })
          ]),
          _createElementVNode("div", {
            class: "child-product-bottom",
            style: _normalizeStyle({ maxHeight: `${_unref(pHeightMax)}px` })
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "child-product-image",
                style: _normalizeStyle(getProductItemStyle(__props.images))
              }, null, 4),
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.child, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.child_product_guid,
                    class: "list-item xag-flex"
                  }, [
                    _createElementVNode("div", {
                      class: "list-item-img",
                      style: _normalizeStyle(getProductItemStyle(item.images))
                    }, null, 4),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_14, "x" + _toDisplayString(item.count), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ], 4)
        ])
      ]),
      _: 1
    }, 8, ["show", "style"])
  ], 64))
}
}

})